import { render } from "./DocumentoView.vue?vue&type=template&id=cd38acb2&scoped=true"
import script from "./DocumentoView.vue?vue&type=script&lang=js"
export * from "./DocumentoView.vue?vue&type=script&lang=js"

import "./DocumentoView.vue?vue&type=style&index=0&id=cd38acb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd38acb2"]])

export default __exports__